import React, { useState, useEffect } from 'react';
import { tippspielAdminAPI } from '../../services/api';

const TippspielSyncStatus = () => {
  const [status, setStatus] = useState(null);
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const [s, l] = await Promise.all([
        tippspielAdminAPI.getSyncStatus(),
        tippspielAdminAPI.getSyncLogs(),
      ]);
      setStatus(s.data);
      setLogs(l.data || []);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  if (loading) {
    return <div className="flex justify-center py-12"><span className="loading loading-spinner loading-lg text-wacker" /></div>;
  }

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="section-title"><span>Sync-Log</span></h2>
        <button type="button" className="btn-wacker-outline text-sm py-2 px-4" onClick={load}>Aktualisieren</button>
      </div>

      <div className="glass-card p-6 grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm">
        <div><span className="text-white/45">API:</span> <span className="text-white">{status?.mfleagueApiStatus}</span></div>
        <div><span className="text-white/45">Letzter Sync:</span> <span className="text-white">{status?.lastSyncAt ? new Date(status.lastSyncAt).toLocaleString('de-DE') : 'Nie'}</span></div>
        <div><span className="text-white/45">Status:</span> <span className="text-white">{status?.lastSyncStatus}</span></div>
        <div><span className="text-white/45">Auto-Sync:</span> <span className="text-white">{status?.syncEnabled ? `Alle ${status.syncIntervalMinutes} Min.` : 'Aus'}</span></div>
        {status?.lastSyncError && (
          <div className="col-span-full text-red-300">{status.lastSyncError}</div>
        )}
      </div>

      <div className="overflow-x-auto glass-card">
        <table className="table w-full text-sm">
          <thead>
            <tr>
              <th>Gestartet</th>
              <th>Status</th>
              <th>Spiele</th>
              <th>Tipps gewertet</th>
            </tr>
          </thead>
          <tbody>
            {logs.map((log) => (
              <tr key={log._id}>
                <td>{new Date(log.startedAt).toLocaleString('de-DE')}</td>
                <td>{log.status}</td>
                <td>{log.matchesUpserted}</td>
                <td>{log.tipsScored}</td>
              </tr>
            ))}
            {logs.length === 0 && (
              <tr><td colSpan={4} className="text-center text-white/50 py-8">Noch keine Sync-Einträge.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TippspielSyncStatus;
